import { swSettings } from "app/common/services/swSettings";

interface SecondaryListClaims {
    isEnabled: boolean;
}

export const getSecondaryListClaims = (): SecondaryListClaims => {
    const resources = swSettings.components?.Activation?.resources as
        | { AlertsSecondaryListEnabled?: boolean }
        | undefined;

    return {
        isEnabled: Boolean(resources?.AlertsSecondaryListEnabled),
    };
};
